(function () {
    const tileRangeListingWrap = document.querySelector('.tiles-range-listings-wrap');
    const sectionTilesRangeListing = document.querySelector('.section-tiles-range-listings');
     //Check for tile range listing class in pagination
     const checkTileRangeListing = document.querySelector('.pagination.tile-range-listing');
    // Sort A-Z/Z-A
    const tilesSort = document.querySelector('.section-tiles-range-listings .tiles-sort');
    const searchField = document.getElementById("range-search-field");

    if(sectionTilesRangeListing){
    if(checkTileRangeListing){
        paginationTilesRange();
    }

    // Pagination function
    function paginationTilesRange() {
        const pagination = document.querySelectorAll(".pagination .page-link");
        for (let i = 0; i < pagination.length; i++) {
        pagination[i].addEventListener("click", function (e) {
            e.preventDefault();
            const pageNoRange = pagination[i].getAttribute("data-pageno");
            let sortTilesType = '';
            if(tilesSort && tilesSort.classList.contains('active')){
                sortTilesType = tilesSort.getAttribute('data-sort');
                if(sortTilesType == 'desc'){
                    sortTilesType = 'asc';
                }else{
                    sortTilesType = 'desc';
                }
            }
            filterTilesCollection(pageNoRange,sortTilesType,'');
            if(sectionTilesRangeListing){
                const scrollPosition = sectionTilesRangeListing.offsetTop;

                window.scroll({
                    top: scrollPosition - 150,
                    behavior: 'smooth'
                });
            }
        });
        }
    }

    if(searchField){
        searchField.addEventListener("keyup",debounce(function(e){
            if(e.key != "Enter"){
                let searchValue = this.value;
                filterTilesCollection(1,'',searchValue);
            }
        },1500));
    
        searchField.addEventListener("keypress",function(e){
            if(e.key == 'Enter'){
                e.preventDefault();
                let searchValue = this.value;
                filterTilesCollection(1,'',searchValue);
            }
        });
    }
    
    if(tilesSort){
        tilesSort.addEventListener('click',function(){
            let sortType = '';
            if(this.hasAttribute('data-sort')){
                sortType = this.getAttribute('data-sort');
            }
            let searchValue = searchField.value != '' ? searchField.value : '';
            this.classList.add('active');
            if(sortType == 'asc'){
                this.setAttribute('data-sort','desc');
                this.innerHTML = 'Sort by Z-A';
            } else if(sortType == 'desc'){
                this.setAttribute('data-sort','asc');
                this.innerHTML = 'Sort by A-Z';
            }
            filterTilesCollection(1,sortType,searchValue);
        });
    }
    
    //Debounce function
    function debounce(callback, delay) {
        let timeout;
        return function () {
            let args = arguments
            clearTimeout(timeout)
            timeout = setTimeout(function () {
                callback.apply(this, args)
            }.bind(this), delay)
        }
    }

    // Filter product function
    function filterTilesCollection(page = 1,sortType='',searchValue='') {
        if(tileRangeListingWrap){
            tileRangeListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
        }
        let filterData = "";
        if(sortType == '' && tilesSort){
            tilesSort.classList.remove('active');
            tilesSort.setAttribute('data-sort','asc');
            tilesSort.innerHTML = 'Sort by A-Z';
        }

        filterData +="&sortType=" + sortType;
        filterData +="&searchValue=" + searchValue;
        // Page data to send in request
        let pageData = "&rangePage=" + page;
        const pageUrlValue = document.getElementById('page-url').value;
        pageUrl = "&pageurl=" + pageUrlValue;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                const loadMoreGif = document.querySelector("#loading");
                if(loadMoreGif){
                    loadMoreGif.remove();
                }
                const responseData = JSON.parse(request.response);
                if (responseData.data.output === 'no-items') {
                    responseHtml = '<span class="no-result">No Results Found</span>';
                }
                else {
                    responseHtml = responseData.data.output;
                }
                if(tileRangeListingWrap){
                    tileRangeListingWrap.innerHTML = responseHtml;
                }
                paginationTilesRange();
                // Call the showImageOnHover after the content is loaded
                showImageOnHover();
            }
        };
        request.send(
        "action=tilesrangelistings&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            filterData+
            pageData +
            pageUrl
        );
    }
}
})();